import searchPageLabels from "../search/searchPageLabels.json";
const { validationMessages } = searchPageLabels;

export const validateSpecialChars = (_, value) => {
  const regex = /^[a-zA-Z0-9]*$/;
  if (value && !regex.test(value)) {
    return Promise.reject(validationMessages.validateSpecialCharsSpaces);
  }
  return Promise.resolve();
};

export const validateName = (_, value) => {
  const regex = /^[a-zA-Z]*$/;
  if (value && !regex.test(value)) {
    return Promise.reject(validationMessages.validateAlphabeticChars);
  }
  return Promise.resolve();
};
